import React, { useEffect, useState, useCallback } from 'react';
import {
  Row,
  Table,
  Tooltip,
  Col,
  Typography,
  Modal,
  Form,
  Input,
  notification,
  Button,
  Checkbox,
  Spin,
} from 'antd';
import { DeleteOutlined, EditOutlined, CheckOutlined } from '@ant-design/icons';
const { Title, Text } = Typography;
import debounce from 'lodash/debounce';
import * as constants from '../utils/constants';
import * as utility from '../utils/utility';
import adminAxiosConfig from '../services/adminAxiosConfig';
// import {
//  } from '../utils/axiosConfig';

const AdminReportingEmailPage = () => {
  const [emailModalVisible, setEmailModalVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [emailData, setEmailData] = useState('');
  const [teamTitle, setTeamTitle] = useState('');
  const [editValue, setEditValue] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedTeamMemberData, setSelectedTeamMemberData] = useState('');
  const [emailForm] = Form.useForm();
  const [reportEmails, setReportEmails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [searchKeyExist, setSearchKeyExist] = useState('');
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const apiEndpoint = '/report-email-recipients';
  const assetManagementEndpoint = '/report-email-recipients';

  const reportMapping = {
    dsrReport: 1,
    ppmReport: 2,
    ppmIssuesReport: 3,
    communicationsReport: 4,
    builtToStandardReport: 5,
    servicetoStandardReport: 6,
    sparePartsOrder: 7,
    qcReport: 8,
    shipmentReport: 9,
    errorReport: Number(constants.REPORT_EMAIL_ERROR_ID),
    safetyStock: 12,
  };

  const reverseReportMapping = {
    1: 'dsrReport',
    2: 'ppmReport',
    3: 'ppmIssuesReport',
    4: 'communicationsReport',
    5: 'builtToStandardReport',
    6: 'servicetoStandardReport',
    7: 'sparePartsOrder',
    8: 'qcReport',
    9: 'shipmentReport',
    13: 'errorReport',
    12: 'safetyStock',
  };

  const columns = [
    {
      dataIndex: 'serialNo',
      key: 'serialNo',
      align: 'center',
      width: '65px',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      align: 'left',
      width: '20%',
    },
    {
      title: 'DSR',
      dataIndex: 'report_ids',
      key: 'dsrReport',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(1) ? <CheckOutlined /> : ''),
    },
    {
      title: 'PPM',
      dataIndex: 'report_ids',
      key: 'ppmReport',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(2) ? <CheckOutlined /> : ''),
    },
    {
      title: 'PPM Issues',
      dataIndex: 'report_ids',
      key: 'ppmIssuesReport',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(3) ? <CheckOutlined /> : ''),
    },
    {
      title: 'Communications',
      dataIndex: 'report_ids',
      key: 'communicationsReport',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(4) ? <CheckOutlined /> : ''),
    },
    {
      title: 'Build to Standard',
      dataIndex: 'report_ids',
      key: 'builtToStandardReport',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(5) ? <CheckOutlined /> : ''),
    },
    {
      title: 'Service to Standard',
      dataIndex: 'report_ids',
      key: 'servicetoStandardReport',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(6) ? <CheckOutlined /> : ''),
    },
    {
      title: 'QC',
      dataIndex: 'report_ids',
      key: 'qcReport',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(8) ? <CheckOutlined /> : ''),
    },
    {
      title: 'Spare Parts Order',
      dataIndex: 'report_ids',
      key: 'sparePartsOrder',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(7) ? <CheckOutlined /> : ''),
    },
    {
      title: 'Shipment',
      dataIndex: 'report_ids',
      key: 'shipmentReport',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(9) ? <CheckOutlined /> : ''),
    },
    {
      title: 'Error report',
      dataIndex: 'report_ids',
      key: 'errorReport',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(13) ? <CheckOutlined /> : ''),
    },
    {
      title: 'Safety Stock',
      dataIndex: 'report_ids',
      key: 'safetyStock',
      align: 'center',
      render: (reportIds) => (reportIds?.includes(12) ? <CheckOutlined /> : ''),
    },
    {
      title: '',
      key: 'action',
      dataIndex: 'action',
      fixed: 'right',
      render: (text, record) => (
        <div>
          <Tooltip title="Update">
            <span className="icon-18 mr-2 cursor-pointer edit-hover">
              <EditOutlined
                style={{ fontSize: '18px' }}
                onClick={() => showEditModal(record)}
              />
            </span>
          </Tooltip>
          <Tooltip title="Delete Member">
            <span
              className="icon-18 mr-2 cursor-pointer edit-hover"
              style={{ marginLeft: '12px' }}
            >
              <DeleteOutlined
                style={{ fontSize: '18px' }}
                onClick={() => showDeleteModal(record)}
              />
            </span>
          </Tooltip>
        </div>
      ),
      align: 'center',
    },
  ];

  const fetchReportList = async () => {
    try {
      setIsLoading(true);
      const response = await adminAxiosConfig.get(apiEndpoint, {
        params: {
          page: currentPage,
          limit: pageSize,
          search: searchKeyExist,
        },
      });
      if (response.data.message === 'success') {
        setReportEmails(response.data.data.data);
        setFilteredEmails(response.data.data.data);
        setTotal(response.data.data.pagination.total);
      }
    } catch (error) {
      console.error('Error fetching report list:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchReportList();
  }, [currentPage, pageSize]);

  const showModal = () => {
    setTeamTitle('Add Email');
    setEmailModalVisible(true);
  };

  const showDeleteModal = (record) => {
    setIsDeleteModalVisible(true);
    setSelectedTeamMemberData(record);
  };

  const showEditModal = (record) => {
    const emailDt = {
      email: record.email,
      reportEmailAccess: record.report_ids.map((id) => reverseReportMapping[id]).filter(Boolean),
    };
    emailForm.setFieldsValue(emailDt);
    setEmailData(record.email);
    setEditValue(true);
    setTeamTitle('Update Email');
    setEmailModalVisible(true);
  };

  const handleCancel = () => {
    emailForm.resetFields();
    setEmailModalVisible(false);
    setEditValue(false);
  };

  const handleOk = async () => {
    emailForm.validateFields().then(async (data) => {
      if (data.reportEmailAccess.length && data.email) {
        try {
          setIsSubmitting(true);
          const response = !editValue
            ? await adminAxiosConfig.post(assetManagementEndpoint, {
                email: data.email,
                report_ids: data.reportEmailAccess.map((report) => reportMapping[report]),
              })
            : await adminAxiosConfig.put(assetManagementEndpoint, {
                email: data.email,
                report_ids: data.reportEmailAccess.map((report) => reportMapping[report]),
              });

          if (response.data.message === 'success') {
            await fetchReportList();
            emailForm.resetFields();
            setEmailModalVisible(false);
            setEditValue(false);
            notification.success({
              message: !editValue ? 'Email added successfully' : 'Email updated successfully',
            });
          }
        } catch (error) {
          console.error('Error with email operation:', error);
          notification.error({
            message: !editValue ? 'Error adding email' : 'Error updating email',
          });
        } finally {
          setIsSubmitting(false);
        }
      } else {
        notification.warning({
          message: 'Please fill all the required fields!',
        });
      }
    });
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
    setSelectedTeamMemberData('');
  };

  const handleDeleteOk = async () => {
    if (selectedTeamMemberData.email) {
      try {
        setIsSubmitting(true);
        const response = await adminAxiosConfig.delete(
          `${assetManagementEndpoint}/${selectedTeamMemberData.email}`
        );
        if (response.data.message === 'success') {
          await fetchReportList();
          setIsDeleteModalVisible(false);
          setSelectedTeamMemberData('');
          notification.success({
            message: 'Email deleted successfully',
          });
        }
      } catch (error) {
        console.error('Error deleting email:', error);
        notification.error({
          message: 'Error deleting email',
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce(async (searchValue) => {
      try {
        setIsLoading(true);
        const response = await adminAxiosConfig.get(apiEndpoint, {
          params: {
            page: currentPage,
            limit: pageSize,
            search: searchValue,
          },
        });
        if (response.data.message === 'success') {
          setReportEmails(response.data.data.data);
          setFilteredEmails(response.data.data.data);
          setTotal(response.data.data.pagination.total);
        }
      } catch (error) {
        console.error('Error searching emails:', error);
      } finally {
        setIsLoading(false);
      }
    }, 500),
    [currentPage, pageSize]
  );

  // Cleanup debounced function on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const onReportSearch = (e) => {
    const searchValue = e.target.value;
    setSearchKeyExist(searchValue);
    debouncedSearch(searchValue);
  };

  return (
    <div className="h-100 overflow-y-hidden overflow-x-hidden">
      <div className="flex-auto">
        <div className="d-flex mb-3 align-items-center tab-content-title">
          <Title
            className="mb-0"
            level={4}
          >
            Reports
          </Title>
          <div className="searchConsumabels">
            <Input
              placeholder="Search By Email"
              onChange={onReportSearch}
              value={searchKeyExist}
              allowClear
            />
          </div>
          <div className="new-project-team">
            <Text
              onClick={showModal}
              className="ps-3 add-new-team"
            >
              <span className="icon-22">
                <svg>
                  <use xlinkHref="#add" />
                </svg>
              </span>
              Add Email
            </Text>
          </div>
        </div>
        <div className="custom-line" />
      </div>
      <Spin spinning={isLoading}>
        <div className="addTeamDetails">
          {filteredEmails.length > 0 ? (
            <Table
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: total,
                onChange: (page, pageSize) => {
                  setCurrentPage(page);
                  setPageSize(pageSize);
                },
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
              }}
              columns={columns}
              dataSource={filteredEmails}
              className="h-100 pipeline-table table-action-column"
              scroll={{ x: filteredEmails.length > 0 ? 1800 : 0, y: 'calc(100vh - 290px)' }}
              loading={isLoading}
            />
          ) : (
            <Table
              pagination={false}
              dataSource={[...filteredEmails]}
              loading={isLoading}
            />
          )}
        </div>
      </Spin>

      <Modal
        width="35vw"
        title={teamTitle}
        centered
        visible={emailModalVisible}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleOk}
            loading={isSubmitting}
          >
            {!editValue ? (isSubmitting ? 'Adding' : 'Add') : isSubmitting ? 'Updating' : 'Update'}
          </Button>,
        ]}
        onCancel={handleCancel}
        maskClosable={!isSubmitting}
        closable={!isSubmitting}
      >
        <Form
          name="basic"
          layout="vertical"
          autoComplete="off"
          form={emailForm}
        >
          <Row gutter={24}>
            <Col lg={24}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: 'Please enter an Email.',
                  },
                  {
                    pattern: constants.EMAIL_PATTERN,
                    message: 'Provide a valid Email.',
                  },
                ]}
                normalize={(value) => utility.trimSpacesInValues(value)}
              >
                <Input
                  size="large"
                  placeholder="Enter Email"
                  disabled={editValue}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            className="mb-0"
            label="Report Email Access"
            name="reportEmailAccess"
            rules={[
              {
                required: true,
                message: 'At least one Report Email Access is required.',
              },
            ]}
          >
            <Checkbox.Group className="w-100">
              <Row>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  className="mb-1"
                >
                  <Checkbox value="dsrReport">DSR</Checkbox>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  className="mb-1"
                >
                  <Checkbox value="ppmReport">PPM</Checkbox>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  className="mb-1"
                >
                  <Checkbox value="ppmIssuesReport">PPM issues</Checkbox>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  className="mb-1"
                >
                  <Checkbox value="communicationsReport">Communications</Checkbox>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  className="mb-1"
                >
                  <Checkbox value="builtToStandardReport">Built to standard</Checkbox>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  className="mb-1"
                >
                  <Checkbox value="servicetoStandardReport">Service to standard</Checkbox>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  className="mb-1"
                >
                  <Checkbox value="qcReport">QC</Checkbox>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  className="mb-1"
                >
                  <Checkbox value="sparePartsOrder">Spare Parts Order</Checkbox>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  className="mb-1"
                >
                  <Checkbox value="shipmentReport">Shipment</Checkbox>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  className="mb-1"
                >
                  <Checkbox value="errorReport">
                    Error report (app / integration failures)
                  </Checkbox>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 12 }} className="mb-1">
                  <Checkbox value="safetyStock">Safety Stock</Checkbox>
                </Col>
              </Row>
            </Checkbox.Group>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        width="45vw"
        className="pipeline-modal"
        title="Delete Team Member"
        centered
        visible={isDeleteModalVisible}
        footer={[
          <Button
            key="cancel"
            onClick={handleDeleteCancel}
            disabled={isSubmitting}
          >
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleDeleteOk}
            loading={isSubmitting}
          >
            {isSubmitting ? 'Deleting' : 'Delete'}
          </Button>,
        ]}
        onCancel={handleDeleteCancel}
        maskClosable={!isSubmitting}
        closable={!isSubmitting}
      >
        <div>
          <Text style={{ fontSize: '16px' }}>
            Are you sure you want to delete{' '}
            <b style={{ color: '#EF314C' }}>
              {selectedTeamMemberData && selectedTeamMemberData.email}
            </b>
            ?
          </Text>
        </div>
      </Modal>
    </div>
  );
};

export default AdminReportingEmailPage;
